export default function ResultsScoreIcon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='49'
      height='48'
      viewBox='0 0 49 48'
      fill='none'
    >
      <path
        d='M25.3244 7L30.5231 17.5321L42.1488 19.2313L33.7366 27.4248L35.7219 39L25.3244 33.5321L14.9269 39L16.9122 27.4248L8.5 19.2313L20.1257 17.5321L25.3244 7Z'
        fill='#408558'
      />
    </svg>
  );
}
